
<template>
    
    
    <div>
        <div style="display:flex; margin:10px 0; ">
            <vs-select
                class="selectExample"
                label="Filter by Month"
                v-model="filter.month"
                @change="updateMonth"
                style="margin-right:20px;"
                >
                <vs-select-item :key="index" :value="month.value" :text="month.name" v-for="month,index in months" />
            </vs-select>

            <vs-select
                class="selectExample"
                label="Filter by Year"
                v-model="filter.year"
                @change="updateYear"
                >
                <vs-select-item :key="index" :value="year.value" :text="year.name" v-for="year,index in years" />
            </vs-select>
        </div>         
    </div>
  </template>
  <script>
    import {mapGetters, mapActions} from 'vuex'
  
    export default {
      data() {
        return {
            filter:{
                month: -1,
                year: new Date().getFullYear()
            },
            months: [
                {
                    name: 'All',
                    value: -1
                },
                {
                    name: 'January',
                    value: 1
                },
                {
                    name: 'Febraury',
                    value: 2
                },
                {
                    name: 'March',
                    value: 3
                },
                {
                    name: 'April',
                    value: 4
                },
                {
                    name: 'May',
                    value: 5
                },
                {
                    name: 'June',
                    value: 6
                },
                {
                    name: 'July',
                    value: 7
                },
                {
                    name: 'August',
                    value: 8
                },
                {
                    name: 'September',
                    value: 9
                },
                {
                    name: 'October',
                    value: 10
                },
                {
                    name: 'November',
                    value: 11
                },
                {
                    name: 'December',
                    value: 12
                }
            ],
            years: [
                {
                    name: 'All',
                    value: -1
                },
                {
                    name: '2022',
                    value: 2022
                },
                {
                    name: '2023',
                    value: 2023
                },
                {
                    name: '2024',
                    value: 2024
                },
                {
                    name: '2025',
                    value: 2025
                }
            ],  
        
        }
      },
      async created() {
        
      },
      computed: {
        
      },
      methods: {
        updateMonth(newMonth){
            this.$emit("filterByMonth", newMonth)
        },
        updateYear(newYear){
            this.$emit("filterByYear", newYear)
        }
      },
      watch: {

      }
    }
  </script>
  
  <style>
  </style>
  